export default "__VITE_ASSET__DKtlHLrn__"